import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Button, Typography, Row, Col } from "antd";
import FormActions from "./FormActions";
import {
  InputItem,
  SelectItem as SelectItemComponent,
  DatePickerItem,
} from "./FormItems";
import { MetaDataSelect, SettingsDataSelect } from "./AutoCompleteFormItem";
import RadioButtonItem from "./RadioButtonItem";
import CheckBoxItem from "./CheckBoxItem";
import ChildrenAnimationWrapper from "../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../animations/AnimationChildWrapper";
import PhoneNumberItem from "./PhoneNumberItem";
import { CloseOutlined } from "@ant-design/icons";
const { Title } = Typography;
const DynamicItemForm = (props) => {
  const {
    mode,
    onFinish,
    onFinishFailed,
    onDecline,
    saveLoading,
    category,
    record,
    name,
    addText,
    twoColumns,
    resource,
    action,
    activeItem,
    onFormChange,
    getInitialItem,
    titleText,
  } = props;
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    if (mode === "edit" && activeItem) {
      var keys = Object.keys(activeItem);
      let item = {};
      keys.forEach((key, i) => {
        item[name + "." + key] = activeItem[key];
      });
      form.setFieldsValue(item);
      checkIfDisabled(item);
    } else {
      form.resetFields();
    }
    if (getInitialItem) {
      getInitialItem(activeItem);
    }
  }, [activeItem, mode]);

  const onSubmit = (values) => {
    // if (mode === "edit") {
    //   values[name + ".id"] = activeItem.id;
    // }
    onFinish(values, mode);
    form.resetFields();
  };

  const onCancel = () => {
    form.resetFields();
    onDecline();
  };

  const onValuesChange = (values, all) => {
    checkIfDisabled(all);
    if (onFormChange) {
      onFormChange(all, values, form);
    }
  };

  const checkIfDisabled = (all) => {
    let result = false;
    record.forEach((item, i) => {
      const n = name + "." + item.title;
      if (item.required) {
        if (all[n] === undefined || all[n] === "") {
          result = true;
        }
      }
    });
    setDisabled(result);
  };

  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  };

  return (
    <div>
      <div className="header" style={{ height: "40px" }}>
        <Button
          style={{ position: "absolute", left: 10, top: 10 }}
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={onCancel}
        />
      </div>
      <Title
        style={{
          fontSize: "30px",
          fontWeight: 500,
          lineHeight: 1.27,
          color: "rgba(0, 0, 0, 0.85)",
          margin: "13px 0 40px 0 ",
          textAlign: "center",
        }}
      >
        {titleText ? titleText : addText}
      </Title>
      <Form
        {...layout}
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
        style={{
          padding: twoColumns ? "0 80px" : "0 128px 0px 128px",
          width: twoColumns ? "900px" : "600px",
        }}
        onValuesChange={onValuesChange}
      >
        <ChildrenAnimationWrapper>
          <Row>
            {record.map((item, i) => (
              <Col
                key={i}
                span={twoColumns ? 12 : 24}
                style={{ padding: "0 20px" }}
              >
                <AnimationChildWrapper key={i} itemKey={i}>
                  {item.type === "input" ? (
                    <InputItem
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                      id={item.localId}
                      email={item.email}
                      disabled={item.disabled}
                      onlyNumbers={item.onlyNumbers}
                      onlyDigits={item.onlyDigits}
                    />
                  ) : item.type === "date" ? (
                    <DatePickerItem
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                      disabledDate={item.disabledDate}
                      disabled={item.disabled}
                    />
                  ) : item.type === "phone" ? (
                    <PhoneNumberItem
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                      disabled={item.disabled}
                    />
                  ) : item.type === "select" ? (
                    <SelectItemComponent
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                      data={item.data}
                      yesNo={item.yesNo}
                      marital={item.marital}
                      gender={item.gender}
                      employeeType={item.employeeType}
                      religion={item.religion}
                      ralative_types={item.ralative_types}
                      disabled={item.disabled}
                      allowClear={item.allowClear}
                    />
                  ) : item.type === "selectItem" ? (
                    <MetaDataSelect
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                      data={item.data}
                      metadataName={item.metadataName}
                      disabled={item.disabled}
                    />
                  ) : item.type === "settingsDataItem" ? (
                    <SettingsDataSelect
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                      data={item.data}
                      settingsdataName={item.settingsataName}
                      getOptionLabel={item.getOptionLabel}
                      disabled={item.disabled}
                    />
                  ) : item.type === "radio" ? (
                    <RadioButtonItem
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                      genders={item.gender}
                      translated={item.translated}
                    />
                  ) : item.type === "checkbox" ? (
                    <CheckBoxItem
                      showLabel={true}
                      name={name + "." + item.title}
                      category={category}
                      required={item.required}
                    />
                  ) : item.formRender ? (
                    item.formRender
                  ) : null}
                </AnimationChildWrapper>
              </Col>
            ))}
            <Row style={{ width: "100%" }}>
              <Col span={24}>
                <FormActions
                  resource={resource}
                  action={action}
                  onCancel={onCancel}
                  hideDelete={true}
                  hideDecline={true}
                  mode={mode}
                  onDecline={onCancel}
                  saveLoading={saveLoading}
                  disabled={disabled}
                />
              </Col>
            </Row>
          </Row>
        </ChildrenAnimationWrapper>
      </Form>
    </div>
  );
};

DynamicItemForm.propTypes = {
  mode: PropTypes.string,
  onFinish: PropTypes.func,
  onFinishFailed: PropTypes.func,
  onDecline: PropTypes.func,
  addImage: PropTypes.func,
  saveLoading: PropTypes.bool,
  category: PropTypes.string,
  name: PropTypes.string,
  record: PropTypes.array,
  resource: PropTypes.string,
  action: PropTypes.string,
};

export default DynamicItemForm;
